import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const FeedbackFab: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const feedbackUrl = useMemo(() => {
    const params = new URLSearchParams({ from: location.pathname });
    return `/feedback?${params.toString()}`;
  }, [location.pathname]);

  if (location.pathname.startsWith('/party/') || location.pathname.startsWith('/feedback')) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => navigate(feedbackUrl)}
      className="fixed bottom-24 right-4 z-50 rounded-full border border-stone-900/10 bg-white px-5 py-3 text-left text-stone-900 shadow-[0_18px_40px_rgba(28,25,23,0.18)] transition-transform hover:-translate-y-0.5 md:bottom-6 md:right-6"
      aria-label="Give feedback or request a feature"
    >
      <span className="block text-sm font-semibold leading-tight">Give Feedback</span>
      <span className="block text-xs text-stone-600">Request Feature</span>
    </button>
  );
};

export default FeedbackFab;